import './instrument';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { loadAdSenseScript } from './utils/loadAdSense';

// Load AdSense script early if configured (needed before first ad unit renders)
loadAdSenseScript();

const root = ReactDOM.createRoot(document.getElementById('root'), {
  onUncaughtError: (err, info) => {
    try {
      // Lazy import to keep entry light if Sentry is disabled.
      // eslint-disable-next-line global-require
      const { reactErrorHandler } = require('@sentry/react');
      reactErrorHandler()(err, info);
    } catch {
      // Ignore if Sentry isn't available/configured.
    }
  },
  onCaughtError: (err, info) => {
    try {
      // eslint-disable-next-line global-require
      const { reactErrorHandler } = require('@sentry/react');
      reactErrorHandler()(err, info);
    } catch {}
  },
  onRecoverableError: (err, info) => {
    try {
      // eslint-disable-next-line global-require
      const { reactErrorHandler } = require('@sentry/react');
      reactErrorHandler()(err, info);
    } catch {}
  },
});
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
